import { Button } from "primereact/button";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import {
  ColumnsProps,
  PossibleColumnProps,
  RowFromView,
  ViewNames,
} from "../types";

type VisibleColumnsDropdownProps<TView extends ViewNames> = {
  allColumns: PossibleColumnProps<RowFromView<TView>>[];
  visibleColumns: PossibleColumnProps<RowFromView<TView>>[];
  setVisibleColumns: (
    columns: PossibleColumnProps<RowFromView<TView>>[],
  ) => void;
};

export default function VisibleColumnsToggle<TView extends ViewNames>({
  allColumns,
  visibleColumns,
  setVisibleColumns,
}: VisibleColumnsDropdownProps<TView>) {
  function onColumnToggle(event: MultiSelectChangeEvent) {
    const selectedColumns = event.value as ColumnsProps[];
    const orderedSelectedColumns = allColumns.filter((column) =>
      selectedColumns.some(
        (selectedColumn: ColumnsProps) => selectedColumn.field === column.field,
      ),
    );

    setVisibleColumns(orderedSelectedColumns);
  }

  return (
    <div className="toolbar-row--inner-container column-toggle-container flex-mobile">
      <MultiSelect
        id="columnToggle"
        value={visibleColumns}
        options={allColumns}
        optionLabel="header"
        onChange={onColumnToggle}
        placeholder="Wybierz kolumny"
        maxSelectedLabels={3}
        selectAllLabel="Zaznacz wszystko"
        selectedItemsLabel="{0} kolumn"
        panelClassName="column-toggle-panel"
      />
      <Button
        icon="pi pi-history"
        iconPos="right"
        onClick={() =>
          setVisibleColumns(
            allColumns.filter((column) => column.isDefaultVisible),
          )
        }
        title="Przywróć domyślne kolumny"
        outlined
      />
    </div>
  );
}
